import orderBy from 'lodash/orderBy';
import values from 'lodash/values';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';

const defaultInitialState = {
	orderControlsDuration: 'asc',
	listOfControls: [{
		name: 'firstGroups',
		placeholder: 'First params',
		orderPosition: 1,
		value: [{ value: 'date', label: 'Date' }],
		multi: false
	}, {
		name: 'secondGroups',
		placeholder: 'Second params',
		orderPosition: 2,
		value: [],
		multi: false
	}]
};

const createGroups = ({
	namespace,
	stateNodeName
}) => {

	const SELECT_VALUE = `${namespace}/${stateNodeName}-select-value`;
	const SWITCH_ORDER_DURATION = `${namespace}/${stateNodeName}-switch-order-duration`;

	// init state
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		groupsSelectValue: (selectName, value ) => ({
			type: SELECT_VALUE,
			payload: {
				selectName,
				value
			}
		}),

		groupsSwitchOrder: () => ({
			type: SWITCH_ORDER_DURATION
		})
	};

	// reducers
	const reducers = {
		[SELECT_VALUE]: (state, action) => {
			const { listOfControls, orderControlsDuration } = state[stateNodeName];

			const newListOfControls = orderBy(
				listOfControls,
				'orderPosition',
				orderControlsDuration
			).map(entity => ({
				...entity,
				value: action.payload.selectName === entity.name ? action.payload.value : entity.value
			}));

			if (isEmpty(newListOfControls[0]['value']) && isEmpty(newListOfControls[1]['value'])) {
				newListOfControls[0]['value'] = defaultInitialState.listOfControls[0]['value'];
			}

			return {
				...state,
				[stateNodeName]: {
					...state[stateNodeName],
					listOfControls: newListOfControls
				}
			};
		},
		[SWITCH_ORDER_DURATION]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				orderControlsDuration: state[stateNodeName].orderControlsDuration === 'asc' ? 'desc' : 'asc'
			}
		})
	};

	// selectors
	const selectors = {
		getControls: state => {
			const { groups: { listOfControls, orderControlsDuration } } = state[namespace];
			const [ first, second ] = orderBy(cloneDeep(listOfControls), ['orderPosition'], [orderControlsDuration]);

			return {
				first,
				second
			};
		},
		getOptions: state => {
			const { table: { groupColumns }, groups: { listOfControls } } = state[namespace];
			const selectedValues = listOfControls.map(entity => entity.value[0] && entity.value[0]['value']);

			return values(groupColumns)
				.filter(entity => selectedValues.indexOf(entity.index) === -1 )
				.map(entity => ({
					value: entity['index'],
					label: entity['title']
				}));
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default  createGroups;

export const getGroupValues = (listOfGroups, orderDuration) => {
	return orderBy(listOfGroups, ['orderPosition'], [orderDuration])
		.filter(entity => entity.value[0] && entity.value[0]['value'])
		.map(entity => entity.value[0]['value']);
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/groups/index.js